import VerificationTemplate from "./VerificationTemplate";

export default function VerifyInfo() {
  return <VerificationTemplate state="info" />;
}
